import type { HelpFile } from '../../types/help'
import { LanguageSwitcherTestIds } from '../../../testids/LanguageSwitcherTestIds'

// Top-bar single-purpose dropdown — its aria-label already describes the action.
export const languageSwitcherHelp: HelpFile = {
  docPage: '/docs/help-system/language',
  texts: {
    [LanguageSwitcherTestIds.btnLanguageSwitcher]: null,
  },
}
